import {
  Button,
  Col,
  CreateTableState,
  Grid,
  Icon,
  Tooltip,
  Typography,
} from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import React, { useEffect, useState } from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { ROUTES } from 'constants/routes'
import { useTranslation } from 'react-i18next'
import StatusIcon from 'modules/Advertisers/List/subcomponents/StatusIcon'
import format from 'utils/dateFns/format'
import { parse } from 'date-fns'
import { StatusBadge } from 'modules/Advertisers/List/subcomponents/StatusBadge'

export const useTableConfig = ({ changeStatus }, data = []) => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    switch (true) {
      case breakpoints.fbs:
        setColumnVisibility({ status: false })
        break

      default:
        setColumnVisibility({})
        break
    }
  }, [breakpoints])

  const tableConfig = {
    columns: [
      {
        id: 'name',
        header: () => (
          <Typography variant={'Body-20'} color={'Label-Primary'}>
            {t('advertisers::list.head.name')}
          </Typography>
        ),
        cell: ({
          row: {
            original: { name, status, id, tax_number, contract, counterparty },
          },
        }) => (
          <Grid wrap={false} gap={16} alignItems={'center'}>
            <Col>
              <StatusIcon status={status} />
            </Col>
            <Grid flexDirection={'column'} gap={4}>
              <Typography
                noMargin
                color={'Label-Fifth'}
                variant={'Form-15'}
                component={
                  <Link to={pathGen(ROUTES.ADVERTISER_EDIT, { id })}>
                    {name}
                  </Link>
                }
              />
              <Typography
                variant={'Body-10'}
                component={<Grid flexDirection={'column'} gap={4} />}
                color={'Label-Secondary'}
              >
                <Col>
                  {t(`advertisers::tax_number_label`)} {tax_number}
                </Col>
                <Col>
                  {t(`advertisers::contract.type.${contract.type}`)} №
                  {contract?.number}{' '}
                  {`${t('common::dated')} ` +
                    format(parse(contract.date, 'yyyy-MM-dd', new Date()))}
                </Col>
                <Col>
                  {t(`advertisers::counterparty_label`)}{' '}
                  {t(`advertisers::counterparty.type.${counterparty.type}`)}{' '}
                  {counterparty.name}
                </Col>
              </Typography>

              {breakpoints.fbs && (
                <Col>
                  <StatusBadge status={status} />
                </Col>
              )}
            </Grid>
          </Grid>
        ),

        className: '',
      },
      {
        id: 'status',
        header: () => (
          <Typography variant={'Body-20'} color={'Label-Primary'}>
            {t('advertisers::list.head.status')}
          </Typography>
        ),
        className: '',
        cell: ({
          row: {
            original: { status },
          },
        }) => <StatusBadge status={status} />,
      },
      {
        id: 'actions',
        header: () => null,
        className: '',
        cell: ({
          row: {
            original: { status, id },
          },
        }) => (
          <Grid justifyContent={'end'} gap={4} wrap={false}>
            <Tooltip
              title={
                status === 'active'
                  ? t('advertisers::set_archive')
                  : t('advertisers::set_active')
              }
            >
              <Button
                noLabel
                variant={'ghost'}
                grey
                startIcon={
                  <Icon
                    name={
                      status === 'active' ? 'inbox-archive' : 'inbox-upload'
                    }
                  />
                }
                size={'m'}
                onClick={() => changeStatus(id, status)}
              />
            </Tooltip>

            <Tooltip title={t('advertisers::edit')}>
              <Button
                variant={'ghost'}
                grey
                component={Link}
                to={pathGen(ROUTES.ADVERTISER_EDIT, { id })}
                noLabel
                startIcon={<Icon name={'edit'} />}
                size={'m'}
              />
            </Tooltip>
          </Grid>
        ),
      },
    ],
    data,
    state: {
      columnVisibility: { ...columnVisibility },
    },
    showHeader: data.length > 0,
    showFooter: false,
    className: 'margin-bottom-16',
  }

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}
